import { useTranslate } from "@tolgee/react";
import React, { Suspense } from "react";
import { usePageInit } from "src/common/hooks";
import { Loading } from "src/components";

const Impersonating = React.lazy(() => import("./Impersonating"));

function ImpersonatingPage(props) {
  const { t } = useTranslate();
  usePageInit(
    t({
      key: "pages.impersonatingPage.pageTitle",
      defaultValue: "Smart Portal - Impersonating",
    }),
  );
  return (
    <Suspense
      fallback={
        <Loading
          addContainer
          active
          loadingText={t({ key: "common.loading", defaultValue: "Loading" })}
        />
      }
    >
      <Impersonating {...props} />
    </Suspense>
  );
}

export default ImpersonatingPage;
